import styled from 'styled-components'

export const DefaultProductImageSwiperContainer = styled.div`
  .swiper-slide {
    opacity: 0;
    transition: all 0.3s;
    &.swiper-slide-active {
      opacity: 1;
      transition: all 0.3s;
    }
  }

  .swiper-pagination {
    opacity: 0;
  }

  .swiper-pagination-bullets {
    bottom: 0px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-pagination-bullet {
    width: 16px;
    height: 3px;
    border-radius: 0px;
    opacity: 0.3;
    background: #66a9ff;
  }

  .swiper-pagination-bullet-active {
    width: 16px;
    height: 3px;
    border-radius: 0px;
    background: #0d71f0;
    opacity: 1;
  }

  @media (max-width: 992px) {
    .swiper-pagination {
      opacity: 1;
    }
  }
`

export const ProductImageSwiperContainer = styled.div`
  .swiper-wrapper {
    display: flex;
  }

  .swiper-slide {
    transition: all 0.3s;

    &.swiper-slide-active {
      opacity: 1;
    }
  }

  .swiper-pagination-bullets {
    bottom: 0px;
    left: 0px;
    display: none;
    align-items: center;
    justify-content: center;
  }

  .swiper-pagination-bullet {
    width: 16px;
    height: 3px;
    border-radius: 0px;
    opacity: 0.3;
    background: #66a9ff;
  }

  .swiper-pagination-bullet-active {
    width: 16px;
    height: 3px;
    border-radius: 0px;
    background: #0d71f0;
    opacity: 1;
  }

  @media (max-width: 992px) {
    .swiper-pagination-bullets {
      display: flex;
    }
  }
`

export const GallerySwiperContainer = styled.div`
  width: 80%;

  .swiper-wrapper {
    width: 100%;
    display: flex;

    .swiper-slide {
      margin-right: 0.5rem;
    }

    .swiper-slide-active {
      transition: all 0.3s;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    background-color: white;
    background-size: 10px 28px;
    height: 4rem;
    margin-top: -31px;
    padding: 0;
  }
`
